<template>
  <v-container>
    <v-layout row>
      <v-flex xs12>
        <v-card>
          <v-toolbar color="blue darken-3" dark>
            <v-toolbar-title>Submitted Sites</v-toolbar-title>

            <v-spacer></v-spacer>
          </v-toolbar>

          <v-layout row fill-height justify-center align-center v-if="loading">
            <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </v-layout>

          <v-list two-line>
            <template v-for="(item, index) in items">
              <v-list-tile :key="index + '-site'" avatar ripple>
                <v-list-tile-action>
                  <v-icon color="grey darken-2">place</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Site</v-list-tile-title>
                  <v-list-tile-sub-title class="text--primary">{{
                    item.address
                  }}</v-list-tile-sub-title>
                  <v-list-tile-sub-title
                    >Submitted for Inspection</v-list-tile-sub-title
                  >
                </v-list-tile-content>
              </v-list-tile>
              <v-divider
                v-if="index + 1 < items.length"
                :key="index"
              ></v-divider>
            </template>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- Snackbar -->
    <v-snackbar v-model="notification" top left :timeout="timeout">
      {{ text }}
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
import jwt_decode from "jwt-decode";
import { router } from "../router";
import { config } from "../config/config";
import { checkLogin } from '../helpers/check'

export default {
  data() {
    return {
      portalUrl: config.apiUrl,
      loading: false,
      text: "Oops! Something went wrong",
      timeout: 6000,
      notification: false,
      items: []
    };
  },
  mounted: function() {
    this.checkLoggedIn();
  },

  methods: {
    retrieveUser() {
      axios.defaults.headers.common["Authorization"] =
        "JWT " + sessionStorage.getItem("token");
      this.loading = true;
      axios
        .get(this.portalUrl + "current-user/")
        .then(res => {
          if (res && res.data && res.data.id) {
            let result = [];
            for (let i = 0; i < res.data.sites.length; i++) {
              if (res && res.data && res.data.sites) {
                if (res.data.sites[i] && res.data.sites[i].inspection_status) {
                  let temp = res.data.sites[i].inspection_status;
                  if (temp == "S") {
                    result.push(res.data.sites[i]);
                  }
                }
              }
            }
            this.items = result;
          }

          this.loading = false;
        })
        .catch(e => {
          this.loading = false;
          this.notification = true;
        });
    },

    checkLoggedIn() {
      if (checkLogin()) {
        router.push("/login");
      }
      else {
        this.retrieveUser();
      }
    },
    inspectToken() {
      const token = this.$session.has("token");
      if (token) {
        const decoded = jwt_decode(sessionStorage.getItem("token"));
        const exp = decoded.exp;
        const orig_iat = decoded.orig_iat;

        if (exp - Date.now() / 1000 < 1800) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    }
  }
};
</script>
